import { useState, useEffect } from "react";
import "../components/content_overlay_latest.css";

function ContentOverlayLatest({ heading, text_content }) {
    return (
      <div id="background_image_for_content">
        <div id="content-overlay3">
          <h2>{heading}</h2>
          <div className="row" style={{ display: "flex", gap: "20px" }}>
            
            {text_content}
          </div>
        </div>
      </div>
    );
  }
  

export default ContentOverlayLatest;
